/*
  Similar pattern to StyledHeader
*/

import styled from "styled-components";

export const StyledFooter = styled.footer`
  width: 100%;
  box-sizing: border-box;
  padding: var(--lib-default-spacing);

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  align-items: center;
  gap: calc(var(--lib-default-spacing) / 2);
`;

export const StyledLandingFooter = styled(StyledFooter)`
  justify-content: center;
`;

export const StyledDetailFooter = styled(StyledFooter)`
  justify-content: space-between;
`;

export const StyledFooterContent = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  align-items: center;
  justify-content: center;
  gap: calc(var(--lib-default-spacing) / 2);

  margin: 0 auto;
  padding: calc(var(--lib-default-spacing) / 2) var(--lib-default-spacing);
  border-radius: 0.25rem;
  background-color: rgba(255, 255, 255, 0.92);
`;

